<<template>  
  <prop-panel @close="close" width="400px">
    <p slot="header">{{rs["regCard"]}}</p>
    
    <div class="row" style="margin-left:0">
        <div class="input-group col-md-11" style="margin-left:0">
          <span class="input-group-addon" >{{rs["empId"]}}</span>
          <input ref="empId" type="number" class="form-control" readonly='true' v-model="empId" >
        </div>
    </div>
    <div class="row" style="margin-left:0">
        <div class="input-group col-md-11" style="margin-left:0">
          <span class="input-group-addon" >{{rs["empName"]}}</span>
          <input type="text" class="form-control" readonly='true' v-model="empName" >
        </div>
    </div>
    <div class="row" style="margin-left:0">
        <div class="input-group col-md-11" style="margin-left:0">
          <span class="input-group-addon" >{{rs["icNo"]}}</span>
          <input ref="expand" type="number" class="form-control" v-model="icNo" >
        </div>
    </div>
    <div slot="footer">
      <button @click.stop="close" type="button" class="btn btn-default" data-dismiss="modal">{{rs["btn_close"]}}</button>
      <button @click.stop="register" type="button" class="btn btn-primary">{{rs["reg"]}}</button>
    </div>
  </prop-panel>
</template>

<<script>
export default {
  created: function() {
    this.icNo = this.icCard
  },
  props:["empId", "empName", "icCard", "rs", "url","detail"],
  data(){
    return {
      icNo:""
    }
  },
  methods:{
    close: function() {
      this.$emit("close");
    },
    register(){
      
      const re = /^[[0-9]*$/
      if (!this.icNo || this.$trim(this.icNo)=="" || !re.test(this.icNo)){
        this.$alert("请先输入正确的IC卡号！")
        return
      }


      const sd = {}
      sd.empId=this.empId
      sd.icNo = this.icNo
      sd.empName = this.empName
      const len = sd.icNo.length
      if (len < 10){
        sd.icNo = "0000000000".substring(len) + sd.icNo
        this.icNo = sd.icNo
      }
      if (this.icCard && this.$trim(this.icCard)!="" && !this.$confirm("旧卡的资料将转到新卡中，是否确认继续？")) return
    
      this.$save(this.url + "register", sd, data=>{
        if (data.rs == 1){
          this.detail.icNo = this.icNo
          this.$alert("登记成功！")
          this.close()
        }
        else if (data.rs ==2){
          this.$alert("卡号已经存在，请检查！")
        }
      });
    }
  }
}
</script>
